import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Search from '../../../assets/Iconsearch.svg';
import DataGridPagination from '../../global/dataGridPagination';
import Loader from '../../global/loader';
import instance from '../../../helpers/axiosInstance';
import { Slide, toast } from "react-toastify";
import SuccessToast from '../../customToast/SuccessToast';
import ErrorToast from '../../customToast/ErrorToast';

const ProductsBody = () => {
    const draftChanges = useRef({});
    const userClaim = useSelector((state) => state.user);
    const [products, setProducts] = useState([]);

    const [originalData, setOriginalData] = useState({});
    const gridRef = useRef();
    const per_page = 25;
    const [pageNo, setPageNo] = useState(1);
    const [loader, setLoader] = useState(false);
    const [searchText, setSearchText] = useState("");

    const handleBulkSave = async () => {
        const updatedPayload = Object.values(draftChanges.current).map((item) => ({
            productId: item.product_id,
            varinatId: item.variant_id,
            hsncode: item.hsncode
        }));

        if (updatedPayload.length === 0) {
            toast(<ErrorToast body="No changes to save." />, {
                transition: Slide,
                hideProgressBar: true,
                autoClose: 2000,
            });
            return;
        }

        try {
            const response = await instance.post(`/app/product/updatehsn`, updatedPayload);
            if (response.status === 200) {
                draftChanges.current = {};
                toast(<SuccessToast body={'HSN Codes updated successfully!'} />, {
                    transition: Slide,
                    hideProgressBar: true,
                    autoClose: 2000,
                });
                getData(pageNo, searchText);
            } else {
                throw new Error("Failed response");
            }
        } catch (error) {
            console.error("Bulk HSN Save Error:", error);
            toast(<ErrorToast body="An error occurred while saving all." />, {
                transition: Slide,
                hideProgressBar: true,
                autoClose: 2000,
            });
        }
    };
    const handleChange = (rowId, product_id, variant_id, hsncode) => {
        draftChanges.current[rowId] = {
            ...draftChanges.current[rowId],
            product_id,
            variant_id,
            hsncode
        }


    };
    const hsnField = ({ data }) => {
        const rowId = data.id;
        const fieldData = data.hsncode ?? '';
        return (
            <input
                type="text"
                inputMode="number"
                pattern="\d{4,10}"
                maxLength={10}
                minLength={4}
                className="form-control form-control-sm"
                placeholder="Enter HSN"
                defaultValue={fieldData}
                onChange={(e) =>
                    handleChange(rowId, data.product_id, data.variant_id, e.target.value)
                }
            />

        );

    }
    const columnData = [
        {
            headerName: 'Product Name',
            field: 'products',
            headerCheckboxSelection: true,
            checkboxSelection: true,
            wrapText: true,
            autoHeight: true,
            flex: 1,
            cellClass: "check-box-container order-number",
            cellRenderer: (param) => {
                // let productNames = param.data.orderProducts;
                //console.log(productNames, param.value)
                return (<div>
                    {param.data.product?.title}
                </div>)
            }
        },
        {
            field: 'title',
            flex: 1,
            wrapText: true,
            autoHeight: true,
            headerName: 'Variant Name',
        },
        {
            flex: 1,
            field: 'sku',
            wrapText: true,
            autoHeight: true,
            headerName: 'SKU',
        },
        {
            flex: 1,
            field: 'hsncode',
            wrapText: true,
            autoHeight: true,
            headerName: 'HSN Code',
            editable: false,
            cellRenderer: hsnField
        }
    ];

    const handlePageClick = (event) => {
        setPageNo(event.selected + 1);
        getData(
            event.selected + 1,
            searchText
        );
    }

    useEffect(() => {
        if (userClaim.token !== "") {
            getData(pageNo, searchText);

        }
    }, [userClaim]);

    const getData = async (
        page = 1,
        searchText,
    ) => {
        var rowData = [];
        setLoader(true);
        try {
            await instance.get(`app/product/getvarent?per_page=${per_page}&page=${page}&search=${searchText}`).then((res) => {

                //console.log(res);
                if (res.status === 200 && Array.isArray(res?.data?.products)) {
                    setProducts(res?.data?.products || []);
                    setOriginalData(res?.data)
                }
                setLoader(false);
            }).catch(e => {
                setLoader(false);
                console.error(e);
                setProducts([]);
            })
        }
        catch (e) {
            setLoader(false);
            console.error(e);
            setProducts([]);
        }
        return rowData;
    }

    const searchTextChangeEvent = (e) => {
        e.preventDefault();
        getData(pageNo, searchText);
    };

    return (
        <>
            <div className="orders-filter-page commom-listing-page page-container pos-relative">
                <div className="topview"><h4 className="fw-600">Products</h4></div>
                <Loader showHide={loader} />
                <div className='row filter-section'>
                    <div className='row filter-section justify-content-between align-items-center'>
                        <div className="filter-left-container">
                            <form onSubmit={searchTextChangeEvent}>
                                <div style={{ position: 'relative' }}>
                                    <span className="icon"><img alt='' src={Search} /></span>
                                </div>
                                <input
                                    type="text"
                                    id="filter-text-box"
                                    placeholder="Search"
                                    className='form-control inputWithIcon'
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                />
                            </form>
                        </div>
                        <div className="filter-right-container">
                            <button className="btn btn-success" onClick={handleBulkSave}>
                                Save All
                            </button>
                        </div>
                    </div>


                </div >
                <DataGridPagination
                    rowData={products}
                    columnDefs={columnData}
                    gridref={gridRef}
                    rowSelection={"multiple"}
                    domLayout="autoHeight"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={originalData.per_page}
                    pageCount={originalData.count}
                    forcePage={pageNo-1}
                />

            </div>
        </>
    );
}

export default ProductsBody;